<template>
    <modal
    name="edit-user-modal"
    :classes="'customModal'"
    :scrollable="true"
    :reset="true"
    :adaptive="false"
    :width="650"
    height="auto"
    @before-open="getData"
    @closed="closeModal()"
  >
    <div class="modalWrapper">
      <div class="content__box">
        <div class="content__box__header">
          <p class="text-white txt--ss opacity--50">Edit User/Operator</p>
        </div>
        <div class="content__divider"></div>
        <div class="content__box__body">
          <div class="form-group">
            <label class="txt--xs txt--off-white mb-2"
              >Email Address</label
            >
            <input
              type="email"
              class="textInputField"
              placeholder="Enter email address(es)"
              v-model="operator.email"
              :disabled="true"
            />
              <!-- <vue-tags-input
                v-model="emailtags"
                :tags="tags"
                @tags-changed="(newTags) => (tags = newTags)"
                :separators="[' ']"
                placeholder="Enter email address(s)"
              /> -->
          </div>
          <label class="txt--xs txt--off-white mb-2">Role(required)</label>
          <!-- <multiselect
            class="multi-select-input"
            v-model="roles"
            :options="role_options"
            :multiple="false"
            :close-on-select="true"
            group-values="permits"
            group-label="poperty"
            :group-select="true"
            placeholder="Select Role"
            label="name"
          >
            <span slot="noResult">Oops! No permit found</span>
            <template slot="tag"
              ><span class="multiselect__tag">
                <span></span>
                <i
                  aria-hidden="true"
                  tabindex="1"
                  class="multiselect__tag-icon"
                ></i> </span
            ></template>
          </multiselect> -->
          <!-- <multiselect v-model="value"  class="multi-select-input" deselect-label="Can't remove this value" track-by="id"  label="name" placeholder="Select one" :options="options" :searchable="true" :allow-empty="false">
            <template slot="singleLabel" slot-scope="{ option }"> {{ option.name }}</template>
          </multiselect> -->
            <multiselect v-model="operator.role" class="multi-select-input"  tag-placeholder="Add this as new Role" placeholder="Select roles" label="name" track-by="id" :options="options" :multiple="false" :taggable="true" @tag="addRoles"></multiselect>


          <label class="txt--xs txt--off-white mb-2"
            >Department(required)</label
          >
           <!-- <multiselect v-model="department"  class="multi-select-input" deselect-label="Can't remove this value" track-by="department_id"  label="department_name" placeholder="Select one" :options="department_options" :searchable="true" :allow-empty="false">
            <template slot="singleLabel" slot-scope="{ department_options }"> {{ department_options.department_name }}</template>
          </multiselect> -->
            <multiselect v-model="operator.department" class="multi-select-input"  tag-placeholder="Add this as new Department" placeholder="Select Department" label="department_name" track-by="department_id" :options="department_options" :multiple="false" :taggable="true" @tag="addTag"></multiselect>
            
          

        </div>
      </div>
      <div class="d-flex justify-content-center flex-wrap mt-4">
        <ButtonWithSpinner class="button button--primary button--sm mr-3" @click="updateOperator"
        :disabled="create_button.disabled"
        :loading="create_button.loading"
        :success="create_button.success"
        >
          Update</ButtonWithSpinner
        >
        <button
          type="button"
          class="button button--outline button--sm"
          @click="closeModal()"
        >
          Cancel
        </button>
      </div>
      <div class="session__modal__close" @click="closeModal()">
        <i class="fas fa-times"></i>
      </div>
    </div>
  </modal>
</template>

<script>
// import VueTagsInput from "@johmun/vue-tags-input";
import "vue-search-select/dist/VueSearchSelect.css";
import ButtonWithSpinner from "@/components/Button";

export default {
    name: "EditUSer",
    components:{
        ButtonWithSpinner
    },
    data(){
        return {
            operator:{
            id:'',    
            role:'',
            department:'',
            status:'',
            email:'',
            },
            value:[],
            options:[],
            department_options:[],
            department:[],
            create_button: {
                disabled: false,
                loading: false,
                success: false,
            },
        }
    },

    created(){
        this.getRoles();
        this.getDepartments();
    },
    methods:{
        closeModal(){
            this.reset();
            this.$modal.hide("edit-user-modal");
        },
        reset(){

          this.value=[];
          this.options=[];
          this.department_options=[];
          this.department=[];
          this.operator.id='';
          this.operator.role='';
          this.operator.department='';
          this.operator.status='';
          this.operator.email='';

          this.create_button.disabled =false;
          this.create_button.loading  =false;
          this.create_button.success =false;
        },
        getData(e){
            // console.log(e);
            this.getRoles();
            this.getDepartments();

            this.operator.id = e.params.operator.id;
            this.operator.email = e.params.operator.email;
            this.operator.role = e.params.operator.role;
            this.operator.department = e.params.operator.department;
            this.operator.status = e.params.operator.status;
           /*  for(let i=0; i<this.options.length; i++){
                for( let j=0; j<this.operator.role.length; j++){
                    
                    if(this.options[i]['id'] == this.operator.role[j]['id'] ){
                        this.this.operator.role[j] == this.options[i];
                    }
                }
            }
            for(let i=0; i<this.department_options.length; i++){
                // console.log(this.options[i]);
                for(let j=0; j<this.operator.department.length; j++){
                    if(this.department_options[i]['department_id'] == this.operator.department[j]['department_id'] ){
                        this.this.operator.department[j] == this.department_options[i];
                    }
                }
            } */
        },
        addTag (newTag) {
            const tag = {
                name: newTag,
                code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
            }
            this.department_options.push(tag)
            this.department.push(tag)
        },
        addRoles(newTag){
                const tag = {
                name: newTag,
                code: newTag.substring(0, 2) + Math.floor((Math.random() * 10000000))
            }
            this.options.push(tag)
            this.value.push(tag)

        },
        getRoles(){
            let owner_id = localStorage.getItem('user_id');

            this.axios
                .post(window.hostname + "/api/auth/role/list", 
                {
                    owner_id:owner_id,
                    status:1,
                }
                ).then((res)=>{
                // console.log(res);
                this.options =res.data.data.role_list;
                //console.log(this.options);
                })
        },
        getDepartments(){
            this.axios
                .post(
                window.hostname + "/api/auth/departments/list",
                {
                    commercial: 1,
                    page: 1,
                    status:1,
                },
                ).then((res)=>{
                   this.department_options =res.data.data.department_list;
                })
        },
        updateOperator(){
           /*  if(this.email == ''){
                this.$toasted.show('Please provide email',{
                    icon : 'times-circle',
                    className: 'error-class'
                });      
                return false;
            } */
            this.create_button.loading = true;
            this.create_button.disabled = true;
            this.create_button.success = false;
            this.axios
                .post(window.hostname + "/api/auth/operator/update", {
                operator_id:this.operator.id,    
                email:this.operator.email,
                role:this.operator.role,
                department:this.operator.department

                }).then((res)=>{
                if(res.data.status){
                    this.$emit('update_list');
                    this.create_button.disabled = false;
                    this.create_button.success = true;
                    this.create_button.loading = false;
                    this.$toasted.show(res.data.message, {
                        icon: "check-circle",
                        className: "success-class",
                    });
                    // this.reset();
                    this.closeModal();
                }
                else{
                    this.create_button.disabled = false;
                    this.create_button.success = false;
                    this.create_button.loading = false;
                    this.$toasted.show(res.data.message,{
                        icon : 'times-circle',
                        className: 'error-class'
                    });             
                }
                // console.log(res);
                })
        }
    }
}

</script>